/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskLanguageTranslationsType from '@jira/spa-apps__project-settings-service-desk-language-translations/src/WithRouterServiceDeskLanguageTranslationsPage.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';
import type {
	Location,
	Query,
	Route,
	Match,
	HistoryAction,
} from '@atlassian/react-resource-router';

export const LazyProjectSettingsServiceDeskLanguageTranslations: LazyComponent<{
	(props: {
		location: Location;
		query: Query;
		route: Route;
		match: Match;
		action: HistoryAction;
	}): React.JSX.Element;
	displayName: string;
}> = lazyForPaint<typeof ProjectSettingsServiceDeskLanguageTranslationsType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-language-translations", jiraSpaEntry: "async-project-settings-service-desk-language-translations" */ '@jira/spa-apps__project-settings-service-desk-language-translations/src/WithRouterServiceDeskLanguageTranslationsPage.tsx'
		),
);

const AsyncProjectSettingsServiceDeskLanguageTranslations = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskLanguageTranslations}
		pageId="project-settings-language-translations"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskLanguageTranslations;
